import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "grid-view-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2 4.75012C2 3.23091 3.23079 2.00012 4.75 2.00012H18.75C20.2692 2.00012 21.5 3.23091 21.5 4.75012V18.7501C21.5 20.2693 20.2692 21.5001 18.75 21.5001H4.75C3.23079 21.5001 2 20.2693 2 18.7501V4.75012ZM4.75 3.50012C4.05921 3.50012 3.5 4.05934 3.5 4.75012V11.0001H11V3.50012H4.75ZM11 12.5001H3.5V18.7501C3.5 19.4409 4.05921 20.0001 4.75 20.0001H11V12.5001ZM20 12.5001V18.7501C20 19.4409 19.4408 20.0001 18.75 20.0001H12.5V12.5001H20ZM20 11.0001H12.5V3.50012H18.75C19.4408 3.50012 20 4.05934 20 4.75012V11.0001Z"
    }, null, -1)
  ])))
}
export default { render: render }